import { useEffect, useState } from 'react'
import { canCheckForContainerApp, isContainerApp } from '../../utils/device'
import { publishGoogleTagManagerEvents } from '../../utils/publishGoogleTagManagerEvents'

function publishCookiebotConsentToGTM(setIsPublished: (isPublished: true) => void) {
    const consent = window?.Cookiebot?.consent ?? undefined
    publishGoogleTagManagerEvents([
        {
            'Cookie consent marketing': Boolean(consent?.marketing),
            'Cookie consent statistics': Boolean(consent?.statistics),
            'Cookie consent preferences': Boolean(consent?.preferences),
        },
    ])

    setIsPublished(true)
}

const useCheckForContainerAppPreTcf22AutoConsent = () => {
    useEffect(() => {
        if (
            !canCheckForContainerApp() ||
            !isContainerApp() ||
            typeof window.__tcfapi !== 'function' ||
            typeof window.Cookiebot !== 'object' ||
            !window.Cookiebot.consented
        ) {
            return
        }

        window.__tcfapi('getTCData', 2, (tcData, success) => {
            if (
                success &&
                typeof window.Cookiebot === 'object' &&
                typeof window.Cookiebot.renew === 'function' &&
                !tcData.tcString &&
                tcData.gdprApplies
            ) {
                window.Cookiebot.renew()
            }
        })
    }, [])
}

const useCookiebotAcceptListener = (): void => {
    const [isPublished, setIsPublished] = useState(false)

    useEffect(() => {
        const publishCookiebotConsentToGTMCallback = () => {
            publishCookiebotConsentToGTM(setIsPublished)
        }

        window.addEventListener('CookiebotOnAccept', publishCookiebotConsentToGTMCallback)

        return () => {
            window.removeEventListener('CookiebotOnAccept', publishCookiebotConsentToGTMCallback)
        }
    }, [])
}

export const CookiebotConfig = () => {
    useCookiebotScript()
    useCookiebotAcceptListener()
    useCheckForContainerAppPreTcf22AutoConsent()

    return (
        <script
            id="CookiebotConfiguration"
            type="application/json"
            data-cookieconsent="ignore"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `{
                        "Frameworks": {
                            "IABTCF2": {
                                "AllowedVendors": [
                                    755, 76, 32, 52, 69, 91, 132, 10, 13, 66, 95,
                                    794, 205, 24, 45, 81, 82, 49, 141, 280, 197,
                                    248, 97, 215, 395, 121, 202, 779, 64, 63, 667,
                                    301, 56, 180, 242, 100, 131
                                ],
                                "AllowedGoogleACVendors": [],
                                "AllowedPurposes": [1, 2, 3, 4, 6, 7, 8, 9, 10, 11],
                                "AllowedSpecialPurposes": [1, 2, 3],
                                "AllowedFeatures": [1,3],
                                "AllowedSpecialFeatures": [1],
                                "VendorRestrictions": []
                            }
                        }
                  }`,
            }}
        />
    )
}

const useCookiebotScript = () => {
    useEffect(() => {
        if (document.getElementById('Cookiebot')) {
            return
        }

        const cookiebotScript = document.createElement('script')
        cookiebotScript.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
        cookiebotScript.setAttribute('type', 'text/javascript')
        cookiebotScript.setAttribute('id', 'Cookiebot')
        cookiebotScript.setAttribute('data-culture', 'EN')
        cookiebotScript.setAttribute('data-framework', 'TCFv2.2')
        cookiebotScript.setAttribute('data-cbid', '027a2704-49bf-4fec-b7c7-65773549910a')

        document.head.appendChild(cookiebotScript)
    }, [])

    return null
}
